import { render, staticRenderFns } from "./SysCodeRuleList.vue?vue&type=template&id=47cfbfd1&scoped=true&"
import script from "./SysCodeRuleList.vue?vue&type=script&lang=js&"
export * from "./SysCodeRuleList.vue?vue&type=script&lang=js&"
import style0 from "./SysCodeRuleList.vue?vue&type=style&index=0&id=47cfbfd1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cfbfd1",
  null
  
)

export default component.exports